import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Input, Spin } from 'antd';
import ProfileInfo from '../MyProfile/ProfileInfo';
import { organisationRequest } from './organisationApi';

export default function OrganisationSettings({ onSaved }) {
  const [form] = Form.useForm();
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const load = async () => {
    setLoading(true); setError('');
    try { const next = await organisationRequest(); setRecord(next); form.setFieldsValue(next); }
    catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };
  useEffect(() => { let active = true; organisationRequest().then(next => { if (active) { setRecord(next); form.setFieldsValue(next); } }).catch(e => { if (active) setError(e.message); }).finally(() => { if (active) setLoading(false); }); return () => { active = false; }; }, [form]);
  const save = async values => {
    setSaving(true); setError(''); setSaved(false);
    try { const next = await organisationRequest(values); setRecord(next); form.setFieldsValue(next); onSaved(next); setSaved(true); }
    catch (e) { setError(e.message); }
    finally { setSaving(false); }
  };
  if (loading) return <Spin aria-label="Loading organisation settings" />;
  if (!record) return <div><Alert type="error" message={error || 'Settings unavailable'} /><Button onClick={load} className="mt-3">Retry</Button></div>;
  return <div className="space-y-6 max-w-[720px]">
    {error && <Alert type="error" showIcon message={error} />}{saved && <Alert type="success" showIcon message="Organisation settings saved." />}
    <div><p className="font-bold">Account type</p><p>{record.accountType === 'PRODUCTION_COMPANY' ? 'Production Company' : 'Advertising Agency'}</p></div>
    <Form form={form} layout="vertical" onFinish={save} disabled={saving}>
      <Form.Item name="name" label="Organisation name" rules={[{ required: true, whitespace: true, max: 120 }]}><Input maxLength={120} /></Form.Item>
      <Form.Item name="description" label="Organisation information"><Input.TextArea maxLength={2000} rows={4} /></Form.Item>
      <Form.Item name="address" label="Organisation address"><Input.TextArea maxLength={500} rows={2} /></Form.Item>
      <Form.Item name="website" label="Website"><Input maxLength={300} /></Form.Item>
      <Button type="primary" htmlType="submit" loading={saving}>Save Settings</Button>
    </Form>
    <div className="border-t pt-5"><h3 className="font-bold text-lg">Administrator account</h3><p className="mt-1">{record.administrator.name} · {record.administrator.email}</p><ProfileInfo embedded /></div>
  </div>;
}